module.exports = __webpack_public_path__ + "static/media/workout-tracker-showcase.c75057b0.png";